import { render, staticRenderFns } from "./AiAgentChat.vue?vue&type=template&id=a5959f1e&scoped=true&"
import script from "./AiAgentChat.vue?vue&type=script&lang=js&"
export * from "./AiAgentChat.vue?vue&type=script&lang=js&"
import style0 from "./AiAgentChat.vue?vue&type=style&index=0&id=a5959f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5959f1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VChip,VIcon,VTextarea})
